const CoApplicantEnum = {
  Occupant: { value: 'occupant', name: 'Yes, occupant' },
  Owner: { value: 'owner', name: 'Yes, owner' },
};

export default CoApplicantEnum;
